export const welcomeScreenStyles = {
  root: "flex flex-1 flex-col items-center justify-center px-5 pb-6 pt-2",
  avatar: "mb-3 h-11 w-11",
  greeting: "text-center text-base font-semibold leading-snug text-strong",
  subtitle: "mt-1 text-center text-sm text-muted-foreground",
  cardList: "mt-5 flex w-full flex-col gap-2",
  card: "gap-3 rounded-xl border-muted bg-white px-3.5 py-3 shadow-sm",
  cardBtn:
    "group w-full text-left transition-all hover:border-ring-border hover:bg-accent/30 hover:shadow-md",
  cardIcon: "flex h-5 w-5 shrink-0 items-center justify-center",
  cardContent: "min-w-0 gap-0",
  cardTitle: "text-sm font-semibold leading-snug text-foreground",
  cardDesc: "mt-0.5 text-xs leading-snug text-subtle",
  cardChevron: "h-4 w-4 shrink-0 text-dim transition-colors group-hover:text-info",
  ghostCard: "animate-pulse gap-3 rounded-xl border-muted bg-white px-3.5 py-3 shadow-sm",
  ghostIcon: "h-5 w-5 shrink-0 rounded-full bg-muted",
  // Bar heights add up to the real card's title + description lines, so the swap doesn't jump.
  ghostContent: "min-w-0 flex-1 gap-2",
  ghostTitle: "h-4 w-1/2 rounded bg-muted",
  ghostDesc: "h-3.5 w-3/4 rounded bg-muted",
};
